<template>
  <div class="cool-toast" v-if="show">
    <div class="toast-text" v-html="text"></div>
  </div>
</template>

<script>
/**
 * 每位工程师都有保持代码优雅的义务
 * each engineer has a duty to keep the code elegant
 */

export default {
  name: 'CoolMToast',
  props: {
    text: {
      default: '',
      type: String
    },
  },
  data: () => {
    return {
      show: false,
    };
  },
};
</script>

<style lang="stylus">
@keyframes cool-toast-fadein
  0%
    background-color rgba(0, 0, 0, 0.1)
  100%
    background-color rgba(0, 0, 0, 0.7)

.cool-toast
  z-index 9999
  position fixed
  left 0
  right 0
  top 0
  bottom 0
  display flex
  align-items center
  justify-content center
  padding-left 10px
  padding-right 10px
  pointer-events none

  .toast-text
    max-width 80%
    margin-top -1rem
    background-color rgba(0, 0, 0, 0.7)
    font-size 16px
    color #fff
    line-height 1.8
    border-radius 4px
    padding 6px 18px
    text-align center
    animation cool-toast-fadein 0.3s
</style>
